import Button from "components/shared/Button";
import { FC, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { TbChevronRight } from "react-icons/tb";
import { HomeModal } from "./HomeModal";
import { ContactModal } from "pages/enterprises/components/HeroSection";

type Props = {
  displayMode?: "desktop" | "mobile";
  onLinkClick?: () => void;
  setOpenForm: (state: boolean) => void;
};

export const AuthButtonsSection: FC<Props> = ({
  displayMode = "desktop",
  onLinkClick,
  setOpenForm,
}) => {
  const [isHomeModalOpen, setIsHomeModalOpen] = useState(false);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const isDesktop = displayMode === "desktop";
  const { pathname } = useLocation();

  const ctaButton = useMemo(() => {
    if (pathname === "/owner") {
      return (
        <a
          href={`https://auth.${process.env.REACT_APP_DOMAIN}/signin`}
          rel='noopener noreferrer'
        >
          <Button
            label='Create a Project'
            style={{
              backgroundColor: "#023061",
              borderColor: "#023061",
              paddingBlock: isDesktop ? 4 : undefined,
              paddingInline: isDesktop ? 12 : undefined,
            }}
          />
        </a>
      );
    }

    if (pathname === "/contractor" || pathname === "/consultant") {
      return (
        <a
          href={`https://auth.${process.env.REACT_APP_DOMAIN}`}
          rel='noopener noreferrer'
        >
          <Button
            label='Create Profile'
            style={{
              backgroundColor: "#023061",
              borderColor: "#023061",
              paddingBlock: isDesktop ? 4 : undefined,
              paddingInline: isDesktop ? 12 : undefined,
            }}
          />
        </a>
      );
    }

    if (pathname === "/lender") {
      return (
        <Button
          label='Book a Demo'
          onClick={() => setIsDemoModalOpen(true)}
          style={{
            backgroundColor: "#023061",
            borderColor: "#023061",
            paddingBlock: isDesktop ? 4 : undefined,
            paddingInline: isDesktop ? 12 : undefined,
          }}
        />
      );
    }
    if (pathname === "/developer") {
      return (
        <Button
          label='Apply for Funding'
          onClick={() => setOpenForm(true)}
          style={{
            backgroundColor: "#023061",
            borderColor: "#023061",
            paddingBlock: isDesktop ? 4 : undefined,
            paddingInline: isDesktop ? 12 : undefined,
          }}
        />
      );
    }

    return (
      <Button
        label='Learn More'
        onClick={() => setIsHomeModalOpen(true)}
        className='!bg-[#023061] !border-[#023061]'
        style={{
          backgroundColor: "#023061",
          borderColor: "#023061",
          paddingBlock: isDesktop ? 4 : undefined,
          paddingInline: isDesktop ? 12 : undefined,
        }}
      />
    );
  }, [pathname, isDesktop]);

  return (
    <>
      <div
        className={`text-sm ${
          isDesktop
            ? "hidden md:flex space-x-6 items-center "
            : "flex flex-col gap-8"
        }`}
      >
        <Link
          to='/contact'
          onClick={onLinkClick}
          className={isDesktop ? "" : "flex items-center justify-between "}
        >
          <Button
            label='Contact Us'
            type='transparent'
            style={{
              color: pathname === "/contact" ? "#60acdb" : "#101828",
              backgroundColor: "transparent",
              padding: 0,
            }}
          />
          {!isDesktop && <TbChevronRight size={20} />}
        </Link>
        <a
          href={`${pathname === "/developer" ? `https://auth.${process.env.REACT_APP_DOMAIN}/project-owner/signup?fromreferralPage=true` : `https://auth.${process.env.REACT_APP_DOMAIN}/signin`} `}
          rel='noopener noreferrer'
          className={isDesktop ? "" : "flex flex-col"}
        >
          <Button
            label={pathname === "/developer" ? "Create a Project" : "Login"}
            type='secondary'
            style={{
              backgroundColor: "white",
              borderColor: "#E6E7E8",
              color: "#101828",
              paddingBlock: isDesktop ? 4 : undefined,
              paddingInline: isDesktop ? 12 : undefined,
            }}
          />
        </a>
        {ctaButton}
      </div>
      {isHomeModalOpen && (
        <HomeModal onClose={() => setIsHomeModalOpen(false)} />
      )}
      {isDemoModalOpen && (
        <ContactModal closer={() => setIsDemoModalOpen(false)} />
      )}
    </>
  );
};
